import {useSubscription, useSubscriptionDispatch} from "./../catalog_context";
import SkeletonLoader from "../skeleton_loader";
import {formatEuro} from "../helper/helpers";
import CountryPackageBundles from "./country_package_bundles";
import PaypalPackageButton from "./paypal_package_button";
import PurchasedPackageButton from "./purchased_package_button";
import DowngradePackageButton from "./downgrade_package_button";
import {isAboutExpire30} from "../helper/helpers";
import {addCartText} from "../helper/constants";

const renewText = gettext("Renew");
const subscribeText = gettext("Subscribe");
const addedCartText = gettext("Added to cart");
const subscriptionExpiredText = gettext("Your Subscription is Expired");
const euroText = formatEuro();
const subscribedText = gettext("Subscribed");
const monthlyText = gettext("/ month");
const activeText2 = gettext("Will be active until");
const expDateText = gettext("Expiration Date:");
const userCountry = catalogModule.getUserCountry();
const vatText = gettext("Including 8.1% VAT");
const yearlyBillText = gettext("Billed annually at");
const specialPackageHeader = gettext("Benefit from the Exclusive FFPLUM Subscription");
const specialPackageText = gettext("Your association has designed this special subscription plan to ensure you have everything you need to fly in France.");
const specialPackageSubText = gettext("Enjoy this tailored solution for FFPLUM members!");
const CatalogSpecialPackage = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const {subscription} = useSubscription();
    const dispatchSubs = useSubscriptionDispatch();
    let isNormalPackage = catalogModule.isUserPkg("ch.xample.group.ffplum.plan");
    let isSpecialPackage = catalogModule.isSpecialPkg("ch.xample.group.ffplum.plan");
    let alreadyBoughtItem = subscription.hasOwnProperty("expiration_date") && subscription.status === 'ready'; // check user if it has subscription
    let isWithin30Days = isAboutExpire30(subscription.expiration_date_ts);

    const getSpecialSubscription = async () => {
        setIsLoading(true);
        let dataRequest = {
            csrfmiddlewaretoken: baseBindData.csrfToken,
            bundle_key: "ch.xample.group.ffplum.plan"
        }
        const request = new Request(
            catalogModule.getUrl("bundle_info"),
            {
                method: "POST",
                headers: {
                    'Content-Type':'application/json',
                    'X-CSRFToken': baseBindData.csrfToken,
                },
                mode: 'same-origin',
                body: JSON.stringify(dataRequest),
            }
        )
        try {
            const resp = await fetch(request).then((response) => response.json())
            // console.log(resp)
            if(resp){
                let tempResp = Object.assign({}, resp);
                if(sort_products){
                    let sortedBundles = sort_products(tempResp.bundles);
                    tempResp.bundles = sortedBundles
                }
                dispatchSubs({
                    type: 'update',
                    payload: tempResp,
                });
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        let tempCatalog = Object.assign({}, catalogModule.catalogData);
        if(tempCatalog && tempCatalog.hasOwnProperty("ffplum_plan") && tempCatalog.ffplum_plan){
            dispatchSubs({
                type: 'update',
                payload: tempCatalog.ffplum_plan
            });
        }
        // getSpecialSubscription();
    }, []);
    let packageButtonRender;
    if(catalogModule.isInCart(subscription.key)) {
        packageButtonRender = <PurchasedPackageButton textButton={addedCartText}
                                                    isDisabled={true} />
    } else {
        if(!catalogModule.hasPackage()){
            if(isSpecialPackage){
                if(subscription.hasOwnProperty('expired') && subscription.expired === 1){
                    if(subscription.status.toLowerCase() !== 'renewing'){
                        packageButtonRender = <PaypalPackageButton productPackage={subscription}
                                                                messageText={true}
                                                                textButton={renewText}
                                                                buttonMessage={subscriptionExpiredText} />
                    }
                }
            } else {
                packageButtonRender = <PaypalPackageButton productPackage={subscription}
                messageText={true}
                textButton={subscribeText}/>
            }
        } else {
            if(alreadyBoughtItem){
                if(isWithin30Days){
                    packageButtonRender =  <PaypalPackageButton productPackage={subscription}
                                                            messageText={true}
                                                            textButton={renewText}
                                                            buttonMessage={expDateText + " " + subscription.expiration_date} />
                } else {
                    packageButtonRender = <PurchasedPackageButton textButton={subscribedText}
                                                                buttonMessage={expDateText + " " + subscription.expiration_date}
                                                                isDisabled={true} />
                }
            } else {
                if(!isSpecialPackage){
                    packageButtonRender = <DowngradePackageButton />
                } else {
                    packageButtonRender = <PurchasedPackageButton textButton={subscribedText}
                                                                isDisabled={true} />
                }
            }
        }
    }
    return (
        <React.Fragment>
            <div className="text-center mb-1">
                <h2>{specialPackageHeader}</h2>
                <p className="m-0">{specialPackageText}</p>
                <p>{specialPackageSubText}</p>
            </div>
            <div className="country_packages">
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-xs-12 col-sm-12 text-center offset-md-4">
                        <div className="card">
                            <div className="card-body">
                                {isLoading && <SkeletonLoader width={'90%'} height={'60px'} />}
                                {!isLoading && <h2>{subscription.name}</h2>}
                                <br />
                                {isLoading && <SkeletonLoader width={'90%'} height={'105px'} />}
                                {!isLoading && <div className="package_price_container">
                                    <h3 className="has-text-anp">
                                        { <React.Fragment>{subscription.monthly_price} {euroText} {monthlyText}</React.Fragment>}
                                        <span>
                                            { subscription.exp_date && <i className="mt-1">{activeText2} {subscription.exp_date}</i>}
                                            {/* { userCountry === "CHE" && <i className="mt-1">{vatText}</i>} ffplum has no vat */}
                                            { subscription.price && <i className="mt-1">{yearlyBillText} {subscription.price} {euroText}</i>}
                                        </span>
                                    </h3>
                                    <br/>
                                </div> }
                                {isLoading && <SkeletonLoader width={'90%'} height={'42px'} />}
                                {!isLoading && packageButtonRender}
                            </div>
                            <CountryPackageBundles productPackage={subscription} isLoading={isLoading} />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CatalogSpecialPackage;
